import script from "./ResultsStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsStudent.vue?vue&type=script&setup=true&lang=js"

import "./ResultsStudent.vue?vue&type=style&index=0&id=4c08892f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c08892f"]])

export default __exports__